import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { waffleCategory } from 'lib/CustomPropTypes';

class WaffleFilter extends React.Component {
  static propTypes = {
    categoryName: PropTypes.string.isRequired,
    categoryValues: PropTypes.arrayOf(waffleCategory),
    value: PropTypes.objectOf(PropTypes.bool),
    onChange: PropTypes.func,
    categoryToDisplay: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  static defaultProps = {
    categoryValues: [],
    value: {},
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
    };
  }

  handleInputChange = (e) => {
    const { target: { value, checked } } = e;
    const { onChange } = this.props;
    onChange(value, checked);
  };

  toggleFilter = () => {
    const { dropdownOpen } = this.state;
    this.setState({
      dropdownOpen: !dropdownOpen,
    });
  };

  showFilter = () => {
    this.setState({
      dropdownOpen: true,
    });
  };

  hideFilter = () => {
    this.setState({
      dropdownOpen: false,
    });
  };

  filterName = () => {
    const { categoryName, categoryToDisplay } = this.props;
    const nameToolkitClasses = [
      'founders-mono', 'f2', 'pb3', 'mb6', 'mh5', 'ma0-l', 'ttu', 'ttn-l',
      'publico-hed-l', 'fw3', 'ls-normal', 'tl', 'tc-l', 'f6-l', 'white-l', 'pa5-l',
    ];

    return (
      <h3 className={classNames('filter-dropdown--filter-mame', nameToolkitClasses)}>
        {
          categoryToDisplay[categoryName]
        }
        {' '}
        <span className="icon icon-angle-down dn dib-l" />
      </h3>
    );
  };

  dropdown = () => {
    const { categoryValues, categoryName, value } = this.props;
    const optionClasses = (active) => classNames(
      'filter-dropdown--option',
      { 'filter-dropdown--disable': !active },
    );
    return (
      <div className="filter-dropdown">
        {categoryValues.map(({ key, name, active }) => (key && name) && (
          <div className={optionClasses(active)} key={key}>
            <input
              id={`input_${name}`}
              type="checkbox"
              className="dn"
              name={categoryName}
              value={key}
              disabled={!active}
              checked={value[key] || false}
              onChange={this.handleInputChange}
            />
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label
              htmlFor={`input_${name}`}
              className={classNames('filter-dropdown--option-label', 'f5 db plum')}
            >
              {name}
            </label>
            {/* eslint-enable jsx-a11y/label-has-for */}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { dropdownOpen } = this.state;
    return (
      <div
        className={classNames(
          'filter-dropdown--filter',
          {
            'filter-dropdown--filter-open': dropdownOpen,
          },
        )}
        onMouseEnter={this.showFilter}
        onMouseLeave={this.hideFilter}
      >
        {this.filterName()}
        {this.dropdown()}
      </div>
    );
  }
}

export default WaffleFilter;
